import React from 'react';
import { Sparkles, ChevronLeft, ChevronRight } from 'lucide-react';
import Button from './ui/Button';
import './SugerenciaIA.css';

// IA-1: botón «Sugerir con IA» (chispas), pequeño, para el ENCABEZADO de un campo (alineado con la
// etiqueta). La tarjeta con la sugerencia va aparte, DEBAJO del campo (SugerenciaIaTarjeta).
export function SugerenciaIaBoton({ onGenerar, cargando = false, disabled = false, title = '' }) {
  return (
    <button type="button" className="pp-ia-boton" onClick={onGenerar} disabled={disabled || cargando} title={title}>
      <Sparkles size={14} aria-hidden="true" />
      <span>{cargando ? 'Generando…' : 'Sugerir con IA'}</span>
    </button>
  );
}

// IA-1 (remate 3): opción «Partir de lo escrito» (default) / «Escribir desde cero», junto al botón de
// Sugerir de la descripción. 'texto' usa la descripción actual como base; 'cero' la ignora.
export function SugerenciaBaseSelector({ value = 'texto', onChange, disabled = false }) {
  return (
    <div className="pp-ia-base" role="radiogroup" aria-label="Base de la sugerencia">
      {[{ v: 'texto', t: 'Partir de lo escrito' }, { v: 'cero', t: 'Escribir desde cero' }].map((o) => (
        <label key={o.v} className={`pp-ia-base-opt${value === o.v ? ' is-sel' : ''}`}>
          <input type="radio" name="pp-ia-base" value={o.v} checked={value === o.v} disabled={disabled}
            onChange={() => onChange && onChange(o.v)} />
          {o.t}
        </label>
      ))}
    </div>
  );
}

// IA-1: tarjeta con la sugerencia, la nota «En qué me basé» y Usar / Regenerar / Descartar. Va DEBAJO
// del campo. La IA PROPONE; «Usar» solo copia al campo (no guarda). Si hay varias generaciones en el
// historial (remate 2), muestra «‹ anterior / siguiente ›» con contador para volver a una previa.
export function SugerenciaIaTarjeta({
  sugerencia = null, nota = null, avisoGenerico = false, cargando = false, error = null,
  indice = 0, total = 0, onAnterior, onSiguiente,
  onGenerar, onUsar, onDescartar,
}) {
  if (error && !sugerencia) return <p className="pp-ia-error">{error}</p>;
  if (!sugerencia) return null;
  return (
    <div className="pp-ia-card">
      {total > 1 && (
        <div className="pp-ia-hist">
          <button type="button" className="pp-ia-hist-btn" onClick={onAnterior} disabled={indice <= 1} aria-label="Sugerencia anterior"><ChevronLeft size={15} aria-hidden="true" /></button>
          <span className="pp-ia-hist-cnt" aria-live="polite">{indice}/{total}</span>
          <button type="button" className="pp-ia-hist-btn" onClick={onSiguiente} disabled={indice >= total} aria-label="Sugerencia siguiente"><ChevronRight size={15} aria-hidden="true" /></button>
        </div>
      )}
      <div className="pp-ia-sug">{sugerencia}</div>
      {avisoGenerico && <p className="pp-ia-aviso">Hay pocos ejemplos de este tipo en la tienda: el resultado puede ser más genérico.</p>}
      {nota && <p className="pp-ia-nota"><strong>En qué me basé:</strong> {nota}</p>}
      <div className="pp-ia-acc">
        <Button size="sm" variant="primary" onClick={onUsar}>Usar</Button>
        <Button size="sm" variant="tertiary" onClick={onGenerar} loading={cargando}>Regenerar</Button>
        <Button size="sm" variant="tertiary" onClick={onDescartar}>Descartar</Button>
      </div>
    </div>
  );
}
